import useSWR from "swr";

import { simpleFetcher } from "../fetcher";

const url = "/api/v2/auth/check-reset-token";

interface TokenCheckResponse {
  isTokenValid: boolean;
  isSsoAvailable: boolean;
}

export function useCheckResetToken(token?: string) {
  return useSWR<TokenCheckResponse, Error>(
    token ? `${url}/${encodeURIComponent(token)}` : null,
    simpleFetcher,
  );
}
